<template>
  <Flex items-center justify-start gap-1 class="py-1 text-xs text-gray-600">
    <IconSolid icon="fa-house" @click="goTo('home')" class="cursor-pointer hover:text-primary-700" />
    /
    <Flex gap-1 center v-for="(item, i) in bread" :key="i" class="cursor-pointer hover:text-primary-700">
      <span @click="goTo(item.name)" v-if="item && item.title" :class="[{ 'font-bold': i >= bread.length - 1 }]">
        {{ item.title }}
      </span>
      <span v-if="i < bread.length - 1"> / </span>
    </Flex>
  </Flex>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const router = useRouter()

const bread = computed(() => route.meta.breadcrumb)

const goTo = (item) => {
  router.push({ name: item })
}
</script>
